<div
  #kpiValueElement
  class="kpi-value"
  [ngClass]="[textColor ? 'color-' + textColor : 'color-primary']">
  {{ kpiValue }}
</div>
